import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type StreamsExternalItem from "./StreamsExternalItem";
import type User from "./User";

@Model()
class ExternalItem extends ApplicationRecord {
  static jsonapiType = "external_items";

  @Attr() advertisementRate: number;

  @Attr() advertisementRateCurrency: string;

  @Attr() archivedAt: string;

  @Attr() audience: number;

  @Attr() medium: string;

  @Attr() publishedAt: string;

  @Attr() sentiment: number;

  @Attr() sourceName: string;

  @HasMany() streamsExternalItems: StreamsExternalItem[];

  @Attr() summary: string;

  @Attr() timeZone: string;

  @Attr() title: string;

  @Attr() url: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default ExternalItem;
